export default {
  // Errors
  notFound: 'انبار یافت نشد',

  // Words
  activeInventories: 'انبارهای فعال',
  businessLicense: 'تصویر پروانه کسب',
  businessLicenseDate: 'تاریخ پروانه کسب',
  businessLicenseNo: 'شماره پروانه کسب',
  capacity: 'ظرفیت انبار',
  cellNumber: 'شماره همراه',
  economicalCode: 'کد اقتصادی',
  enterInventory: 'نام انبار را وارد کنید',
  inventory: 'انبار',
  inventoryActived: 'انبار فعال شد',
  inventoryName: 'نام انبار',
  inventoryRemoved: 'انبار حذف شد',
  inventorySuspended: 'انبار تعلیق شد',
  inventoryUpdated: 'انبار به روز رسانی شد',
  kilogram: 'کیلوگرم',
  managerName: 'نام مالک',
  managerNationalCode: 'کد ملی مالک',
  nationalId: 'شناسه ملی',
  newInventoryAdded: 'انبار جدید افزوده شد',
  operatorName: 'متصدی انبار',
  phoneCode: 'پیش شماره تلفن ثابت',
  phoneNumber: 'شماره تلفن ثابت',
  profileStatus: 'وضعیت پروفایل',
  suspendedInventories: 'انبارهای تعلیق شده',
  valueAddedRegCert: 'تصویر گواهی ثبت نام ارزش افزوده از سایت evat.ir',
  workingHours: 'ساعات کار روزانه'
}